
<app-snackbar></app-snackbar>
<section class="home-wrap">
  <section class="hm-banner">
    <div class="wrap-lg banner-inner">
      <h1 class="banner-title">Education Loan</h1>
      <h3 class="hm-desc">“Partnership-based <span class="mob-wrap">loans for Education”</span></h3>
      <div class="cus-dropdown" >
        <div class="page-search">
          <input type="text"  class="cus-input" (input)="searchCourse($event)" (click)="searchCourse($event)"  placeholder="Search your school/institute"/>
          <svg class="search-icon" width="48" height="40" viewBox="0 0 48 40" fill="none" >
            <path d="M3.08964 10.2988C1.54977 5.16589 5.39334 0 10.7522 0H40C44.4183 0 48 3.58172 48 8V32C48 36.4183 44.4183 40 40 40H17.9522C14.4194 40 11.3048 37.6827 10.2896 34.2988L3.08964 10.2988Z" fill="#17151C"/>
            <path d="M27.6 27.2C31.7974 27.2 35.2 23.7974 35.2 19.6C35.2 15.4026 31.7974 12 27.6 12C23.4026 12 20 15.4026 20 19.6C20 23.7974 23.4026 27.2 27.6 27.2Z" stroke="#10D7EE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M36.0002 28L33.2002 25.2" stroke="#10D7EE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div id="page_search" *ngIf="searchData" class="drop-content open">
          <div class="drop-item" (click)="selectCourse(data); searchData = null" *ngFor="let data of searchData.content">{{data.name}}</div>
        </div>
      </div>
    </div>
  </section>
  <section class="hm-about">
    <div class="wrap-lg">
      <div class="about-inner">
        <h2 class="hm-title">About Us</h2>
        <div class="hm-desc">Northern Arc is a diversified financial service platform catering to varied credit requirements of <span class="wrap-text">households & businesses by providing cost effective and timely access to debt finance.</span></div>
        <div class="counter-list">
          <div class="counter-item">
            <div class="counter-value">{{customerApplied}}</div>
            <div class="counter-label">CUSTOMERS APPLIED</div>
          </div>
          <div class="counter-item">
            <div class="counter-value">{{totalAmountDisbursed}} {{totalAmountDisbursedUnit}}</div>
            <div class="counter-label">AMOUNT DISBURSED</div>
            <div class="gradient-line dark"></div>
          </div>
          <div class="counter-item">
            <div class="counter-value">{{totalDisbursedCount}}</div>
            <div class="counter-label">DISBURSEMENT COUNT</div>
            <div class="gradient-line dark"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="hm-process">
    <div class="wrap-lg">
      <h2 class="hm-title">Our Loan Process</h2>
      <div class="hm-desc">Start your journey to secure the loan.</div>
      <div class="process-slide">
        <div class="left">
          <div *ngFor="let item of processItems; index as i" class="process-item " (click)="(activateProcess(i))" [ngClass]="{
            active: item.isSelected,
          }">
            <div class="ico-sec" >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" *ngIf="i === 0">
                <path d="M22 9V16.46C22 18.75 20.14 20.6 17.85 20.6H6.15C3.86 20.6 2 18.75 2 16.46V9H22Z" fill="#17151C"/>
                <path class="sv_fill_theme_icon" d="M22 7.54039V9.00039H2V7.54039C2 5.25039 3.86 3.40039 6.15 3.40039H17.85C20.14 3.40039 22 5.25039 22 7.54039Z" fill="#878D92"/>
                <path class="sv_fill_theme_icon" d="M8 17.25H6C5.59 17.25 5.25 16.91 5.25 16.5C5.25 16.09 5.59 15.75 6 15.75H8C8.41 15.75 8.75 16.09 8.75 16.5C8.75 16.91 8.41 17.25 8 17.25Z" fill="#878D92"/>
                <path class="sv_fill_theme_icon" d="M14.5 17.25H10.5C10.09 17.25 9.75 16.91 9.75 16.5C9.75 16.09 10.09 15.75 10.5 15.75H14.5C14.91 15.75 15.25 16.09 15.25 16.5C15.25 16.91 14.91 17.25 14.5 17.25Z" fill="#878D92"/>
              </svg>
              <svg width="24" height="24" viewBox="0 0 24 24" *ngIf="i === 1" fill="none">
                <g id="document-text">
                <g id="document-text_2">
                <path id="Vector" d="M20.5 10.19H17.61C15.24 10.19 13.31 8.26 13.31 5.89V3C13.31 2.45 12.86 2 12.31 2H8.07C4.99 2 2.5 4 2.5 7.57V16.43C2.5 20 4.99 22 8.07 22H15.93C19.01 22 21.5 20 21.5 16.43V11.19C21.5 10.64 21.05 10.19 20.5 10.19Z" fill="#17151C"/>
                <path class="sv_fill_theme_icon" id="Vector_2" d="M15.7997 2.21048C15.3897 1.80048 14.6797 2.08048 14.6797 2.65048V6.14048C14.6797 7.60048 15.9197 8.81048 17.4297 8.81048C18.3797 8.82048 19.6997 8.82048 20.8297 8.82048C21.3997 8.82048 21.6997 8.15048 21.2997 7.75048C19.8597 6.30048 17.2797 3.69048 15.7997 2.21048Z" fill="#878D92"/>
                <path class="sv_fill_theme_icon" id="Vector_3" d="M13.5 13.75H7.5C7.09 13.75 6.75 13.41 6.75 13C6.75 12.59 7.09 12.25 7.5 12.25H13.5C13.91 12.25 14.25 12.59 14.25 13C14.25 13.41 13.91 13.75 13.5 13.75Z" fill="#878D92"/>
                <path class="sv_fill_theme_icon" id="Vector_4" d="M11.5 17.75H7.5C7.09 17.75 6.75 17.41 6.75 17C6.75 16.59 7.09 16.25 7.5 16.25H11.5C11.91 16.25 12.25 16.59 12.25 17C12.25 17.41 11.91 17.75 11.5 17.75Z" fill="#878D92"/>
                </g>
                </g>
              </svg>
              <svg width="24" height="24" viewBox="0 0 24 24" *ngIf="i === 2" fill="none">
                <g id="clock">
                <g id="clock_2">
                <path id="Vector" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#17151C"/>
                <path class="sv_fill_theme_icon" id="Vector_2" d="M15.7106 15.9298C15.5806 15.9298 15.4506 15.8998 15.3306 15.8198L12.2306 13.9698C11.4606 13.5098 10.8906 12.4998 10.8906 11.6098V7.50977C10.8906 7.09977 11.2306 6.75977 11.6406 6.75977C12.0506 6.75977 12.3906 7.09977 12.3906 7.50977V11.6098C12.3906 11.9698 12.6906 12.4998 13.0006 12.6798L16.1006 14.5298C16.4606 14.7398 16.5706 15.1998 16.3606 15.5598C16.2106 15.7998 15.9606 15.9298 15.7106 15.9298Z" fill="#878D92"/>
                </g>
                </g>
              </svg>
              <svg width="24" height="24" viewBox="0 0 24 24" *ngIf="i === 3" fill="none">
                <g id="coin">
                <g id="coin_2">
                <path class="sv_fill_theme_icon" id="Vector" d="M9.99 17.98C14.4028 17.98 17.98 14.4028 17.98 9.99C17.98 5.57724 14.4028 2 9.99 2C5.57724 2 2 5.57724 2 9.99C2 14.4028 5.57724 17.98 9.99 17.98Z" fill="#878D92"/>
                <path id="Vector_2" d="M21.9701 15.9901C21.9701 19.2901 19.2901 21.9701 15.9901 21.9701C13.9501 21.9701 12.1601 20.9501 11.0801 19.4001C15.4401 18.9101 18.9101 15.4401 19.4001 11.0801C20.9501 12.1601 21.9701 13.9501 21.9701 15.9901Z" fill="#17151C"/>
                <g id="Group 772544539">
                <path id="Vector_3" d="M12.998 7.1875H7.79688H9.21538C9.71699 7.1875 10.1981 7.38677 10.5528 7.74146C10.9074 8.09615 11.1067 8.57722 11.1067 9.07884C11.1067 9.58045 10.9074 10.0615 10.5528 10.4162C10.1981 10.7709 9.71699 10.9702 9.21538 10.9702H7.79688L10.6339 13.8072" stroke="#17151C" stroke-width="1.10328" stroke-linecap="round" stroke-linejoin="round"/>
                <path id="Vector_4" d="M7.79688 9.08105H12.998" stroke="#17151C" stroke-width="1.10328" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                </g>
                </g>
              </svg>
            </div>
            <div class="process-name">{{item.title}}</div>
          </div>
          <!-- <div class="process-item">
            
          <div class="process-item">
            
            <div class="process-name">Quick Approval</div>
          </div>
          <div class="process-item">
            <div class="ico-sec">
              
            </div>
            <div class="process-name">Flexible Repayment</div>
          </div> -->
        </div>
        <div class="right">
          <img [src]="activeProcessItem?.img" alt="Process Slide"/>
        </div>
      </div>
    </div>
  </section>
  <section class="hm-repayment">
    <div class="wrap-lg">
      <h2 class="hm-title">Transparent Repayments</h2>
      <div class="hm-desc">Tracking of loan status and payment schedules</div>
      <div class="repayment-list">
        <div class="list-item">
          <img src="assets/images/home/repayment_moratorium.svg" alt="Moratorium">
          <div class="repay-name">Moratorium</div>
          <div class="repay-desc">Pay only interest for the loan amount during the moratorium period.</div>
        </div>
        <div class="list-item">
          <img src="assets/images/home/repayment_uninterrupted_earning.svg" alt="Uninterrupted Learning">
          <div class="repay-name">Uninterrupted Learning</div>
          <div class="repay-desc">Access financing for academic needs without disruption</div>
        </div>
        <div class="list-item">
          <img src="assets/images/home/repayment_flexible.svg" alt="Flexible Repayments">
          <div class="repay-name">Flexible Repayments</div>
          <div class="repay-desc">Multiple repayment structures, according to financial needs</div>
        </div>
      </div>
    </div>
  </section>
  <section class="hm-testimonial">
    <div class="wrap-lg">
      <h2 class="hm-title">Testimonials</h2>
      <div  *ngIf="customers && customers.length" class="customer-sec">
        <div class="testi-desc">What Our Customers Say</div>
        <div class="customer-slide">
          
          <p-carousel [value]="customers || []" [numVisible]="1" [page]="testimonialsPage" (onPage)="changePage($event)" [numScroll]="1" [circular]="true"  [showIndicators]="false">
            <ng-template let-customer pTemplate="item">
              <div class="cust-slide-item left">
                <div class="cust-icon">
                  <img *ngIf="customers[prevItemIndex].image" [src]="customers[prevItemIndex].image" alt="rr" />
                  <div *ngIf="!customers[prevItemIndex].image" alt="rr">{{customers[prevItemIndex].nameInitials}}</div>
                  <span class="quote"><img src="assets/images/home/testimonial_quote.png" alt="Quote" /></span>
                </div>
                <div class="cust-detail">
                  <div class="cust-desc">{{ customers[prevItemIndex].description }}</div>
                  <div class="cust-name">{{ customers[prevItemIndex].name | titlecase  }}{{ (customers[prevItemIndex].designation? (', '+customers[prevItemIndex].designation):'') | titlecase }}</div>
                </div>
              </div>
              <div class="cust-slide-item ">
                <div class="cust-icon">
                  <img *ngIf="customer.image" [src]="customer.image" alt="rr" />
                  <div *ngIf="!customer.image" alt="rr">{{customer.nameInitials}}</div>
                  
                  <span class="quote"><img src="assets/images/home/testimonial_quote.png" alt="Quote" /></span>
                </div>
                <div class="cust-detail">
                  <div class="cust-desc">{{ customer.description }}</div>
                  <div class="cust-name">{{ customer.name | titlecase  }}{{ customer.designation? (', '+customer.designation):''  | titlecase }}</div>
                </div>
              </div>
              <div class="cust-slide-item right">
                <div class="cust-icon">
                  <img *ngIf="customers[lastItemIndex].image" [src]="customers[lastItemIndex].image" alt="rr" />
                  <div *ngIf="!customers[lastItemIndex].image" alt="rr">{{customers[lastItemIndex].nameInitials}}</div>
                  <span class="quote"><img src="assets/images/home/testimonial_quote.png" alt="Quote" /></span>
                </div>
                <div class="cust-detail">
                  <div class="cust-desc">{{ customers[lastItemIndex].description }}</div>
                  <div class="cust-name">{{ customers[lastItemIndex].name | titlecase }}{{ customers[lastItemIndex].designation? (', '+customers[lastItemIndex].designation):'' | titlecase }}</div>
                </div>
              </div>
            </ng-template>
          </p-carousel>
        </div>
      </div>
      <div class="partner-sec">
        <div class="wrap-lg">
          <div class="testi-desc">What Our Partners Say</div>
          <div class="partner-slide">
            <div class="partner-item" *ngFor="let cus of partnerCustomers">
              <div class="partner-icon"><img [src]="cus.image" alt=""/></div>
              <div class="partner-detail">
                <div class="partner-desc">{{cus.description}}</div>
                <div class="partner-name">{{cus.name | titlecase }}</div>
              </div>
            </div>
            <!-- <div class="partner-item">
              <div class="partner-icon"><img src="assets/images/home/partner_2.png" alt=""/></div>
              <div class="partner-detail">
                <div class="partner-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent </div>
                <div class="partner-name">UpGrad</div>
              </div>
            </div>
            <div class="partner-item">
              <div class="partner-icon"><img src="assets/images/home/partner_2.png" alt=""/></div>
              <div class="partner-detail">
                <div class="partner-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent </div>
                <div class="partner-name">UpGrad</div>
              </div>
            </div>
            <div class="partner-item">
              <div class="partner-icon"><img src="assets/images/home/partner_1.png" alt=""/></div>
              <div class="partner-detail">
                <div class="partner-desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent </div>
                <div class="partner-name">UpGrad</div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="hm-download">
    <div class="wrap-lg">
      <div class="download-inner">
        <img class="app-screen" src="assets/images/home/download_mobile.svg" alt="Download our NorthernArc Mobile App"/>
        <div class="download-detail">
          <h2 class="hm-title">Download our <span class="wrap-text">NorthernArc Mobile App</span></h2>
          <div class="hm-desc">Scan the QR to download the App</div>
          <div class="download-option">
            <img class="qr-icon" src="assets/images/home/playStoreQR.png" alt="Download App"/>
            <span class="or-text">or</span>
            <img class="store-icon" (click)="playstoreApp()" src="assets/images/home/download_app_playstore.svg" alt="Download App"/>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="hm-contact">
    <div class="wrap-lg">
      <div class="contact-inner">
        <div class="ico-sec">
          <img src="assets/images/home/contact_img.png" alt=""/>
        </div>
        <div class="contact-detail">
          <h2 class="hm-title">“We Hear You”</h2>
          <div class="hm-desc">From New Loans to Existing Inquiries, <span class="wrap-text">We're Here to Support You.</span></div>
          <button class="btn-theme" (click)="util.route('contactUs')">Contact Us</button>
        </div>
      </div>
    </div>
  </section>
</section>
